<template>
    <div class="max-w-3xl mx-auto my-10">
        <p class="text-center mb-5 text-lg font-bold">Nous vous remercions de rentrer le numéro présent sous le code
            barre de votre billet.</p>
        <div class="flex items-center gap-4 mb-4">
            <img class="w-32 md:w-64" src="/img/osv_img.png" alt="image osv ticketing">
        </div>
        <p class="text-center mb-5 text-lg font-bold">Astuce : vous pouvez le copier depuis le PDF reçu par email
            directement dans la barre ci-dessous !</p>
        <osv-use-ticketing-barcode />
    </div>
</template>

<script>
export default {
    props: {
        content: null
    },
    created() {
    }
}
</script>

<style lang="scss" scoped>
</style>